import * as React from "react";

import { cn } from "~/lib/utils";
import { blurOnWheel } from "~/lib/blur-on-wheel";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onWheel, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        data-slot="input"
        onWheel={
          type === "number"
            ? (e) => {
                // Bug-205: shared with raw number inputs via ~/lib/blur-on-wheel.
                blurOnWheel(e);
                onWheel?.(e);
              }
            : onWheel
        }
        className={cn(
          "file:text-main placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-11 w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/50 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
